module.exports = __webpack_public_path__ + "img/function_img5_fan.6b9d2339.png";